import { useTheme } from '@/shared/ui/theme/ThemeProvider';

/**
 * Global recovery screen shown by Sentry's ErrorBoundary.
 *
 * It deliberately has no dependency on the router, profile, or translations:
 * those providers can be part of the failure that brought the user here.
 */
export function ErrorSentryPage() {
  const { C, T } = useTheme();

  const reloadApplication = () => {
    window.location.reload();
  };

  return (
    <main
      role="alert"
      aria-live="assertive"
      style={{
        minHeight: '100vh',
        padding: '30px',
        background: T.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'inherit',
      }}
    >
      <section
        style={{
          width: '100%',
          maxWidth: 407,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <div
          aria-hidden="true"
          className="mi-anim-check-pop"
          style={{
            width: 99,
            height: 99,
            borderRadius: '50%',
            background: `${C.danger}18`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 23,
          }}
        >
          <div style={{ width: 75, height: 75, borderRadius: '50%', background: C.danger, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width={33} height={33} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </div>
        </div>

        <h1 style={{ margin: 0, color: T.clockText, fontSize: 23, fontWeight: 700, lineHeight: 1.25 }}>
          No se pudo continuar
        </h1>
        <p style={{ maxWidth: 330, margin: '8px 0 0', color: T.text, fontSize: 12, fontWeight: 700, lineHeight: 1.7 }}>
          Ocurrió un problema inesperado. Recarga la aplicación para continuar con tu jornada.
        </p>
        <p style={{ margin: '8px 0 0', color: T.textMuted, fontSize: 10, lineHeight: 1.5 }}>
          Si el problema continúa, comunícate con el administrador del sistema.
        </p>

        <button
          type="button"
          data-testid="error-sentry-reload"
          onClick={reloadApplication}
          style={{
            marginTop: 26,
            padding: '11px 28px',
            border: 'none',
            borderRadius: 9,
            background: C.primary,
            color: '#fff',
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 700,
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 7,
          }}
        >
          <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
            <path d="M3 12a9 9 0 1 0 3-6.7" />
            <path d="M3 4v5h5" />
          </svg>
          Recargar aplicación
        </button>
      </section>
    </main>
  );
}
